import { RootState } from '../types'

export const getSeoSelector = (state: RootState) => state.seo
